import DIApi from '../di/_diApi';
import httpClient from '@/apis/base/httpclient';
class HistoryAccessAPI extends DIApi {
  apiName = 'Business';
  controllerName = 'AuditLogs';

  /**
   * Lấy dữ liệu mặc định tài khoản bán hàng
   * bdanh 28.02.2024
   */
  async saveLog(payload) {
    const request = {
      url: this.getAPIUrl() + '/Logs',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }
}

export default new HistoryAccessAPI();
